<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-tab :to="tab.path" @click="tab.click">
    <div v-if=" tab.isLoad" class="tab-content">
      <v-progress-circular
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="tab-content">
      {{ tab.name }}

      <v-badge v-if="tab.path==='/overview' && $store.state.$user" :value="$store.state.$user.unread_notifications>0" bottom color="red"
               offset-x="8px" offset-y="8px" overlap
               right>
        <template v-slot:badge>
          {{ $store.state.$user.unread_notifications }}
        </template>
        <v-img :src="tab.img" class="tab-img" max-height="24" max-width="24"/>
      </v-badge>

      <v-badge v-else :color="tab.badge_color?tab.badge_color:'green'" :value="tab.badge" bottom offset-x="8px"
               offset-y="8px" overlap
               right>
        <template v-slot:badge>
          {{ tab.badge_number }}
        </template>
        <v-img :src="tab.img" class="tab-img" max-height="24" max-width="24"/>
      </v-badge>
    </div>
  </v-tab>

</template>
<style lang="scss" scoped>

</style>

<script lang="ts">

import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class TabForDialog extends Vue {
  @Prop() tab: any
}

</script>
